export const RECEIVE_BACK_IN_STOCK_VARIANTS = "RECEIVE_BACK_IN_STOCK_VARIANTS";
export const UPDATE_BACK_IN_STOCK_VARIANTS = "UPDATE_BACK_IN_STOCK_VARIANTS";
